import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=532d3e3a&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=532d3e3a&scoped=true&lang=css&"
import style1 from "./Product.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532d3e3a",
  null
  
)

export default component.exports